import React from "react";
import { baseConfig } from "../../config";
import "./Footer.css";

function Footer() {
  return <div className="footer">{baseConfig.footerText}</div>;
}

export default Footer;
